import { useEffect, useState } from "react";
import { TOKEN_KEY } from "@/lib/api";
import { logSecurityEvent } from "@/components/SecurityLog";
import { TouchGuard } from "@/components/TouchGuard";

const inCall = () => !!document.querySelector('[data-testid="call-screen"]');
const authed = () => !!localStorage.getItem(TOKEN_KEY);
const report = (kind, context) => { if (authed()) logSecurityEvent(kind, context); };

const blockKeys = (e) => {
  const k = e.key?.toUpperCase();
  if (e.key === "F12" || (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(k)) || (e.ctrlKey && ["U", "S", "P"].includes(k)) || e.key === "PrintScreen") {
    e.preventDefault();
    e.stopPropagation();
  }
};

export const SecurityShield = ({ children }) => {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const ctx = (e) => e.preventDefault();
    const vis = () => { setHidden(document.hidden && !inCall()); if (document.hidden && inCall()) report("app_hidden", "കോളിനിടെ"); };
    const restore = () => { if (!document.hidden) setHidden(false); };
    const shot = (e) => {
      if (e.key === "PrintScreen") {
        try { navigator.clipboard?.writeText("RATHRI — സ്ക്രീൻഷോട്ട് നിരോധിച്ചിരിക്കുന്നു"); } catch (err) { /* ignore */ }
        setHidden(true);
        setTimeout(() => setHidden(false), 2500);
        report("screenshot", inCall() ? "കോളിനിടെ" : null);
      }
    };
    const keyReport = (e) => {
      const k = e.key?.toUpperCase();
      if (e.key === "F12" || (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(k))) report("devtools", null);
      if (e.ctrlKey && k === "P") report("print", null);
    };
    const origGDM = navigator.mediaDevices?.getDisplayMedia?.bind(navigator.mediaDevices);
    if (navigator.mediaDevices && origGDM) {
      navigator.mediaDevices.getDisplayMedia = async (...args) => { report("screen_record", "getDisplayMedia"); setHidden(true); setTimeout(() => setHidden(false), 3000); throw new DOMException("സ്ക്രീൻ റെക്കോർഡിംഗ് നിരോധിച്ചിരിക്കുന്നു", "NotAllowedError"); };
    }
    document.addEventListener("contextmenu", ctx);
    document.addEventListener("keydown", blockKeys, true);
    document.addEventListener("keydown", keyReport, true);
    document.addEventListener("keyup", shot, true);
    document.addEventListener("visibilitychange", vis);
    window.addEventListener("focus", restore);
    window.addEventListener("pageshow", restore);
    document.addEventListener("pointerdown", restore, true);
    return () => {
      document.removeEventListener("contextmenu", ctx);
      document.removeEventListener("keydown", blockKeys, true);
      document.removeEventListener("keydown", keyReport, true);
      document.removeEventListener("keyup", shot, true);
      document.removeEventListener("visibilitychange", vis);
      window.removeEventListener("focus", restore);
      window.removeEventListener("pageshow", restore);
      document.removeEventListener("pointerdown", restore, true);
      if (navigator.mediaDevices && origGDM) navigator.mediaDevices.getDisplayMedia = origGDM;
    };
  }, []);
  return (
    <div data-testid="security-shield" className={hidden ? "privacy-blur" : ""} onDragStart={(e) => e.preventDefault()}>
      {children}
      <TouchGuard />
      {hidden && (
        <div data-testid="privacy-blackout" onClick={() => setHidden(false)} className="fixed inset-0 z-[100] bg-black flex flex-col items-center justify-center gap-3 text-sm text-white/80">
          <span className="w-12 h-12 rounded-2xl bg-white/10 inline-flex items-center justify-center text-2xl">🔒</span>
          <p className="font-semibold">സ്ക്രീൻ ഓഫ് — സ്വകാര്യതാ സംരക്ഷണം</p>
          <p className="text-[11px] text-white/50">സ്ക്രീൻഷോട്ട് / സ്ക്രീൻ റെക്കോർഡിംഗ് നിരോധിച്ചിരിക്കുന്നു</p>
        </div>
      )}
    </div>
  );
};
